import { CircularProgress } from "@mui/material";
import useStyles from "@helpers/theme/useStyles";
import BaseButton from "@components/library/UI/BaseButton";
import "./CopytradeButton.sass";

import { ReactComponent as FireIcon } from "@assets/images/icons/fire-regular-full.svg";

export const CopytradeButton = ({
  children,
  onClick,
  disabled = false,
  className = "",
  // to = "/",
  isLoading = false,
}) => {
  const style = useStyles();

  return (
    <BaseButton
      as="button"
      // to={to}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`copytrade-button ${className}`}
      // type={type}
    >
      {isLoading && (
        <CircularProgress
          size={24}
          thickness={3.6}
          sx={{
            color: style.main,
            mr: "12px",
          }}
        />
      )}
      {children}

      {disabled && <FireIcon />}
    </BaseButton>
  );
};
